import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const url = new URL(window.location.href)
    const appointmentId = url.searchParams.get("appointment_id")
    if (!appointmentId) return

    url.searchParams.delete("appointment_id")
    history.replaceState({}, "", url.toString())

    fetch(`/my/appointments/${appointmentId}`, {
      credentials: "same-origin",
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type") || ""
        const html = await response.text()

        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)
        }
      })
      .catch((error) => {
        console.error("Error loading appointment:", error)
      })
  }
}
